import { render, staticRenderFns } from "./CategoryMobile.vue?vue&type=template&id=5606afb7&"
import script from "./CategoryMobile.vue?vue&type=script&lang=js&"
export * from "./CategoryMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports